import { localeManager, t } from '../i18n/index.js';

const languageNames = { en: 'English', id: 'Indonesia', su: 'Sunda', ms: 'Melayu', ar: 'العربية', ja: '日本語', ko: '한국어', zh: '中文', es: 'Español' };

export function Header() {
  return `
    <header class="site-header">
      <a class="brand" href="/" data-link aria-label="KIPS DESIGN home"><span class="brand-mark" aria-hidden="true">KD</span><span>KIPS <strong>DESIGN</strong></span></a>
      <button class="nav-toggle" type="button" aria-label="Toggle navigation" aria-expanded="false" data-nav-toggle>☰</button>
      <nav class="site-nav" aria-label="Primary navigation" data-site-nav>
        <a href="/" data-link>${t('nav.home')}</a>
        <a href="/catalog" data-link>${t('nav.catalog')}</a>
        <a href="/studio/house/house-tropical-urban-compact-001" data-link>${t('nav.studio')}</a>
        <a href="/about" data-link>${t('nav.about')}</a>
        <a href="/contact" data-link>${t('nav.contact')}</a>
      </nav>
      <div class="header-actions">
        <label class="sr-only" for="locale-select">Language</label>
        <select id="locale-select" class="locale-select" aria-label="Language">
          ${localeManager.getSupported().map((locale) => `<option value="${locale}" ${locale === localeManager.locale ? 'selected' : ''}>${languageNames[locale]}</option>`).join('')}
        </select>
        <a class="button button-primary header-cta" href="/catalog" data-link>${t('action.start')}</a>
      </div>
    </header>`;
}

export function mountHeader(root) {
  root.querySelector('[data-nav-toggle]')?.addEventListener('click', (event) => {
    const navigation = root.querySelector('[data-site-nav]');
    const expanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
    event.currentTarget.setAttribute('aria-expanded', String(!expanded));
    navigation?.classList.toggle('is-open', !expanded);
  });
  root.querySelector('#locale-select')?.addEventListener('change', (event) => localeManager.setLocale(event.target.value));
}
